import React from 'react';
import { ANNOUNCEMENT_SECTIONS } from '../constants/announcementContent';

function NoticeView({ hidden }) {
  return (
    <section
      className="page-view notice-view"
      id="notice-view"
      role="tabpanel"
      hidden={hidden}
    >
      <main className="container page-main">
        <h1 className="page-title">招聘公告</h1>
        <article className="announcement-copy">
          {ANNOUNCEMENT_SECTIONS.map((section) => (
            <section key={section.title}>
              <h2>{section.title}</h2>
              {(section.paragraphs || []).map((paragraph) => (
                <p key={paragraph.slice(0, 20)}>{paragraph}</p>
              ))}
              {section.list ? (
                <ol className="plain-list">
                  {section.list.map((item) => (
                    <li key={item.slice(0, 20)}>{item}</li>
                  ))}
                </ol>
              ) : null}
              {section.footer ? <p>{section.footer}</p> : null}
            </section>
          ))}
        </article>
      </main>
    </section>
  );
}

export default NoticeView;
